export const galleryImageRecommendedSize = Object.freeze({
  SliderItem: '326x206',
  InfiniteSlider: '910x575',
  TemplateGridBig: '560x560',
  TemplateGridSmall: '210x160',
});

export const stripImageRecommendedSize = Object.freeze({
  StripsTemplateWithButton: '330x330',
  StripsTemplateWithPlainImages: '440x440',
  StripsTemplateWithLongText: '82x82',
});

export const partnersImageRecommendedSize = '422x240';

export const sectionImageRecommendedSize = '1440x300';
